<script lang="ts">import { Container } from "@infinitro/container";
import "../api/api";
import Banner from "./banner.svelte";
export let race;
export let raceId = undefined;
</script>

<Container width="56.25rem">
	<Banner {race} {raceId} />
</Container>

<style>
</style>
